import { defineMessages } from 'react-intl';

export const texts = defineMessages({
  inputPlaceholder: {
    id: 'Search.inputPlaceholder',
    description: 'Input placeholder for search term',
    defaultMessage: 'Sök'
  }
});
